import React from "react";
import { Link } from "react-router-dom";
import { Button } from "components/generic/kit";
import { Container, Message } from "components/generic/layout";
import { candidate } from "routes/paths";
import { Overlay } from "components/common/candidate";

export default ({ isNotCallTime, status, info, controls }) => (
  <Overlay>
    {isNotCallTime ? (
      <div>
        <Message
          title="Oops! Your call is scheduled for another time, please come back during your scheduled time slot."
          text="Please check your calendar invite or dashboard to see the correct time for this call. You can also browse other insiders in the meantime :)!"
          footer={
            <div className="flex justify-center">
              <Link to={candidate.main}>
                <Button>Show me more insiders</Button>
              </Link>
            </div>
          }
        />
      </div>
    ) : (
      <Container>
        <div className="bg-white pv3 ph3 br2 mv5">
          {status === "open" ? (
            <div>
              <div className="bb b--black-10 pb1 fw6 mb3">You're on a call</div>
              <div className="flex justify-center mb2">
                <Button onClick={controls.end} color="red">
                  End the call
                </Button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center mb2">
              <Button
                color="white"
                disabled={status === "connecting"}
                onClick={controls.start}
              >
                Start the call!
              </Button>
            </div>
          )}
          <div className="mb3">
            <div className="bb b--black-10 pb1 fw6 mb2">Call overview</div>
            <div className="f6">
              <div>
                <span className="fw6">Date:</span> {info.date}
              </div>
              <div>
                <span className="fw6">Insider:</span> {info.resume}
              </div>
              <div>
                <span className="fw6">Company:</span> {info.company.name}
              </div>
              <div>
                <span className="fw6">Duration:</span> {info.duration} minutes
              </div>
              <div>
                <span className="fw6">Price:</span> {info.price}
              </div>
            </div>
          </div>
        </div>
      </Container>
    )}
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Call/View.js